"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.investingDateUtil = void 0;
var format_1 = __importDefault(require("date-fns/format"));
var parse_1 = __importDefault(require("date-fns/parse"));
var investingFormat = 'MM/dd/yyyy';
exports.investingDateUtil = {
    dateToStr: function (date) { return format_1.default(date, investingFormat); },
    strToDate: function (dateISO) { return parse_1.default(dateISO, investingFormat, new Date()); },
};
